function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null);

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Sidebar---Right---Person-Selected",
  transform: "translate(-12.000000, -12.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-9"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-7",
  transform: "translate(12.000000, 12.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-10"
}, /*#__PURE__*/React.createElement("g", {
  id: "if_group_309042"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(11.000000, 0.000000)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5,9 C20.4,9 22,14 22.1,14 C22.1,15.1045695 21.2045695,16 20.1,16 L16.1,16 C14.9954305,16 14.1,15.1045695 14.1,14 L14.1,13.8 L14,12.6 C13.9,12.5 13.3,11.1 11.9,9.9 C12.8,9.4 14,9 15.5,9 Z M15.5,7 C13.5670034,7 12,5.43299662 12,3.5 C12,1.56700338 13.5670034,0 15.5,0 C17.4329966,0 19,1.56700338 19,3.5 C19,5.43299662 17.4329966,7 15.5,7 Z M3,3.5 C3,1.6 4.6,0 6.5,0 C8.4,0 10,1.6 10,3.5 C10,5.4 8.4,7 6.5,7 C4.6,7 3,5.4 3,3.5 Z M6.5,9 C11.4,9 13,14 13,14 C13,15.1045695 12.1045695,16 11,16 L2,16 C0.8954305,16 1.3527075e-16,15.1045695 0,14 C0,14 1.6,9 6.5,9 Z",
  id: "Combined-Shape",
  fill: "#9399AC",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29,8 C29,7.44771525 28.5573397,7 28.0010434,7 L26,7 L26,4.99895656 C26,4.44724809 25.5561352,4 25,4 L25,4 C24.4477153,4 24,4.44266033 24,4.99895656 L24,7 L21.9989566,7 C21.4472481,7 21,7.44386482 21,8 L21,8 C21,8.55228475 21.4426603,9 21.9989566,9 L24,9 L24,11.0010434 C24,11.5527519 24.4438648,12 25,12 L25,12 C25.5522847,12 26,11.5573397 26,11.0010434 L26,9 L28.0010434,9 C28.5527519,9 29,8.55613518 29,8 L29,8 Z",
  id: "Combined-Shape",
  fill: "#9399AC",
  transform: "translate(25.000000, 8.000000) rotate(-360.000000) translate(-25.000000, -8.000000) "
})))))));

var SvgAddPeople = function SvgAddPeople(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "16px",
    viewBox: "0 0 29 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddPeople, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AddPeople.4525afa1.svg";
export { ForwardRef as ReactComponent };